import Vue from 'vue'
import {
    Table,
    Switch,
    Pagination,
    Tooltip,
    TableColumn,
    Button,
    Submenu,
    MenuItem,
    message,
    Input,
    Form,
    FormItem,
    Container,
    Header,
    Aside,
    Main,
    Menu,
    Breadcrumb,
    BreadcrumbItem,
    Card,
    Row,
    Col,
    Dialog,
    MessageBox,
    Tag,
    Tree,
    Select,
    Option,
    Cascader
} from 'element-ui'
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Input)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Tag)
Vue.use(Tree)
Vue.use(Select)
Vue.use(Option)
Vue.use(Cascader)
Vue.prototype.$message = message
Vue.prototype.$confirm = MessageBox.confirm